/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import {
    object,
} from 'prop-types';
import { connect } from 'react-redux';

import {
    getFlags,
} from '../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { payPayPluginConfig } from '../../../../../../../../state/ducks/MfeCheckout/ducks/Payment/PaymentMethods/Paypal';

const queryStringBuilder = (params) => {
    let queryString = '';
    Object.keys(params).forEach((p) => {
        queryString = `${queryString}&${p}=${params[p]}`;
    });
    return queryString;
};

const loadScript = (paypalSDKParams) => {
    const PAYPAL_SCRIPT = `${payPayPluginConfig.sdkURL}?${paypalSDKParams}`;
    const script = document.createElement('script');
    script.setAttribute('src', PAYPAL_SCRIPT);
    document.head.appendChild(script);
};

function LoadPayPalScript({
    flags,
}) {
    useEffect(() => {
        if (typeof window !== 'undefined' && !window.paypal) {
            const getPayPalSDKConfig = () => {
                let paypalConfig = {};

                if (flags['which-paypal-flow'] === 'CHECKOUT_WITH_VAULT_FLOW') {
                    paypalConfig = {
                        'client-id': payPayPluginConfig.paypalClientId,
                        currency: 'USD',
                        vault: true,
                        intent: 'authorize',
                        'disable-funding': 'card',
                        commit: false,
                        components: 'buttons,messages',
                    };
                } else if (flags['which-paypal-flow'] === 'VAULT_FLOW') {
                    paypalConfig = {
                        intent: 'tokenize',
                        'client-id': payPayPluginConfig.paypalClientId,
                        currency: 'USD',
                        vault: true,
                        'disable-funding': 'card',
                    };
                }

                return queryStringBuilder(paypalConfig);
            };

            if (flags['which-paypal-flow'] === 'CHECKOUT_WITH_VAULT_FLOW' || flags['which-paypal-flow'] === 'VAULT_FLOW') {
                const paypalSDKParams = getPayPalSDKConfig();

                loadScript(paypalSDKParams);
            }
        }
    }, []);

    return null;
}

LoadPayPalScript.propTypes = {
    flags: object.isRequired,
};

const mapStateToProps = (state) => ({
    flags: getFlags(state),
});

export default connect(mapStateToProps)(LoadPayPalScript);
